import { render, staticRenderFns } from "./DimensioningTable.vue?vue&type=template&id=0461c420&"
import script from "./DimensioningTable.vue?vue&type=script&lang=js&"
export * from "./DimensioningTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports